export const PlanViewModelMixin = Target => class SwivuModelMixin extends Target {
  // There are two projects in the app. One is the main one which has a transport layer and all the stores.
  // Another one is a project specifically for the Plan view. Those projects use different stores for
  // events, resources and assignments. E.g. planProject.resourceStore.first will return a Task instead of
  // Resource.
  // There are not many places yet which actually require this logic, mostly models and mixins shared by two projects.
  // Ideally, every model should mix this in and all project references from the model should use this property.
  // But that would be a lot of refactoring for no good reason. I suggest to use this mixin in PlanView and related
  // entities only
  get swivuProject() {
    return this.project?.mainProject ?? this.project;
  }
};
